require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M41 4H9a5 5 0 0 0-5 5v32a5 5 0 0 0 5 5h32a5 5 0 0 0 5-5V9a5 5 0 0 0-5-5zM17 20v19h-6V20zm-6-5.531C11 13.07 12.2 12 14 12s2.93 1.07 3 2.469C17 15.87 15.879 17 14 17c-1.8 0-3-1.129-3-2.531zM39 39h-6V29c0-2-1-4-3.5-4.04h-.078C27 24.96 26 27.02 26 29v10h-6V20h6v2.559S27.93 20 31.809 20C35.78 20 39 22.73 39 28.262zm0 0"
  }));
};

exports["default"] = _default;